export default __webpack_public_path__ + "right-bg435f37e.png";